export default "__VITE_ASSET__DphNJFDU__"